import React, { Fragment, useEffect, useState } from "react";
import { GeoAltFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { getUserAddressApi } from "../../../../Api/PanelAdminServices";
import Button from "../../../Button/Button";
import Style from "./AddressList.module.scss";
import { errorToast } from "../../../../Utils/Toast/Toast";

const AddressList = ({ rawInfo, handleOk }) => {
  const [address, setAddress] = useState([]);
  useEffect(() => {
    userAddress();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const userAddress = async () => {
    getUserAddressApi(rawInfo.userId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setAddress(res.address);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  return (
    <Fragment>
      <div className={Style.componentHolder}>
        {address &&
          address.map((item) => {
            return (
              <section key={item.id} className={Style.centerHolder}> 
                <div className={Style.addressHolder}>
                  <GeoAltFill
                    style={{ color: "#666666", fontSize: "1.1rem" }}
                  />
                  <p className={Style.Address}>{item.address}</p>
                </div>
                <Link to={{pathname:`/editaddress/${item.id}`,state:item.id}}>
                  <Button Value={"ویرایش"} ClassBtn={"okBtn"} />
                </Link>
              </section>
            );
          })}
      </div>
      <div className={Style.btnHandler}>
        <Button Value={"تایید"} ClickHandler={handleOk} ClassBtn={"okBtn"} />
      </div>
    </Fragment>
  );
};
export default AddressList;
